import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { NoInternetComponent } from './no-internet.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    NoInternetComponent
  ],
  exports: [NoInternetComponent]
})
export class NoInternetModule {}

